<nz-row nzAlign="middle" nzGutter="8" nzJustify="end">
  <nz-col nzSpan="6"></nz-col>
  <nz-col nzSpan="6"></nz-col>
  <nz-col nzSpan="6"></nz-col>
  <nz-col nzSpan="6"></nz-col>
</nz-row>
